// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COUNSELLING_SHOW_MORE = "Viac z poradne...";
export const TOPIC_COUNSELLOR = "Odborn\u00edk";
